import { Injectable } from "@angular/core";
import { NestApiProvider, FormDataUpload } from "../../nestjs/nest-api";
import { Observable } from "rxjs";
import { ResponseData } from "../../nestjs/nest-responses";

@Injectable()
export class AttendanceFaceRecognizeApi {

	private model: string = 'attendanceFaceRecognize';

	constructor(
		private nestApiProvider: NestApiProvider
	) {

	}

	public deleteUserPhoto(payload: { id: number }): Observable<ResponseData<any>> {
		const method: string = 'POST';
		const func: string = 'deleteUserPhoto';
		const params: any = payload;
		const urlParams: any = {};
		const body: any = {};
		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.model);
		return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
	}

	urlAddUserPhoto() {
		const method: string = 'POST';
		const func: string = 'addUserPhoto';
		const params: any = {};
		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, {}, this.model);
		return url;
	}

	public downloadTemplateTenant() {
		const method: string = 'GET';
		const func: string = 'downloadTemplate';
		const params: any = {};
		const urlParams: any = {};
		const body: any = {};
		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.model);
		return this.nestApiProvider.requestBlob<Blob>(method, url, func, params, body);
	}

	public uploadFileUserTenant(file: File, fileName: string) {
		const method: string = 'POST';
		const func: string = 'uploadFileUserTenant';
		const params: FormDataUpload[] = [
      {
        name: 'files',
        value: file,
        fileName: fileName
			}
		];

		const urlParams: any = {};
		const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.model);
		return this.nestApiProvider.requestUpload<ResponseData<any>>(method, url, params);
	}



}


// WEBPACK FOOTER //
// ./src/shared/thermal/services/attendance-face-recognize.api.ts